import { render } from "./treeShowTemp.vue?vue&type=template&id=3af31d1e"
import script from "./treeShowTemp.vue?vue&type=script&lang=js"
export * from "./treeShowTemp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__